import { get } from "./api";
import mvpVaultVideos from "../data/mvpVaultVideos.json";

export const fetchVaultResources = (category, view, params) => {
  const url = `/api/v2/vault/${category}/${view}`;
  return get(url, params ?? undefined);
};

export const fetchDownloadLink = (id) => {
  const url = `/api/v2/resourcedownload/${id}/download/`;
  return get(url);
};

export const fetchVaultCaptions = (mediaHashedId, language) => {
  if (!mediaHashedId) {
    return Promise.resolve({
      available_captions: [],
      selected_caption: null,
    });
  }
  const url = `/api/v2/vault/captions/${encodeURIComponent(mediaHashedId)}/`;
  return get(url, language ? { language } : undefined);
};

function getNextPageNumber(nextUrl) {
  if (!nextUrl) return null;
  try {
    const url = new URL(nextUrl);
    const page = Number(url.searchParams.get("page"));
    return Number.isFinite(page) && page > 0 ? page : null;
  } catch {
    return null;
  }
}

function extractVaultResults(response) {
  if (Array.isArray(response)) return response;
  if (Array.isArray(response?.results)) return response.results;
  return [];
}

async function fetchAllVideos(fetchPage) {
  const firstResponse = await fetchPage();

  const firstResults = extractVaultResults(firstResponse);
  const firstNextPage = getNextPageNumber(firstResponse?.next);
  if (!firstNextPage) {
    return firstResults;
  }

  // Fallback path: if backend is paginated, collect all pages.
  const allResults = [...firstResults];
  let page = firstNextPage;
  while (page) {
    const response = await fetchPage(page);
    allResults.push(...extractVaultResults(response));
    page = getNextPageNumber(response?.next);
  }

  return allResults;
}

async function fetchMvpVaultVideosLocal(page) {
  return fetchVaultResources("video", "all", {
    ...(page ? { page } : {}),
    searchTerm: "",
  });
}

/** Build a lookup keyed by String(id) so numeric and string ids both match. */
const mvpVaultById = new Map(mvpVaultVideos.map((v) => [String(v.id), v]));

/**
 * Returns a download URL from the given item's resource_file.
 * Handles both plain string and { url } object shapes from the API.
 */
export function getResourceFileUrl(item) {
  const rf = item?.resource_file;
  if (typeof rf === "string" && rf.trim()) return rf.trim();
  if (rf && typeof rf === "object" && typeof rf.url === "string" && rf.url.trim())
    return rf.url.trim();
  return null;
}

/**
 * Looks up a resource_file URL from mvpVaultVideos.json by matching id.
 * Used as a reliable fallback when the API omits or nulls resource_file.
 */
export function getResourceFileFromJson(video) {
  const entry = mvpVaultById.get(String(video?.id));
  return entry ? getResourceFileUrl(entry) : null;
}

export const getMvpVaultVideos = async () => {
  // Use the JSON directly for MVP — it has the correct resource_file URLs and
  // stable IDs. The API is not yet seeded with matching data.
  return mvpVaultVideos;
};